<!--
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-09-07 19:28:08
 * @LastEditTime: 2021-12-31 16:19:51
-->
<template>
  <div v-if="data" class="li flex align-center" :class="type?'justify-end':''" @click="handleApp(data)">
    <img v-if="data.platform===1" class="margin-right" :src="google">
    <img v-else-if="data.platform>=2" class="margin-right" :src="ios">
    <img :src="data.icon">
    <div class="right">
      <p class="artist"> {{ data.name }}</p>
      <p class="introduce artist"> {{ data.artist }}</p>
    </div>
  </div>
</template>
  
<script>
import google from 'assets/images/icon/icon-google.svg'
import ios from 'assets/images/icon/icon-apple.svg'
export default {
  name: '',
  //import 引入组件
  components: {
 
  },
  props:{
    data:{
      type:Object,
      required:true
    },
    type:{
      type:Boolean,
      default:false
    }
  },
  setup(_,ctx){
    const handleApp=(item)=>{
      ctx.emit('handleApp',item)
    }
    return {handleApp,google,ios}
  }
}
</script>
  
<style scoped lang="scss">
    .li {
      padding: 10px;

      img {
        width: 28px;
        height: 28px;
        border-radius: 15%;

        &:nth-child(1) {
          width: 14px;
          height: 14px;
          margin-right: 8px;
        }
      }

      .right {
        margin-left: 5px;
        text-align: left;
        overflow: hidden;

        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .artist {
          color: $fontColor;
          font-size: $fontCommon;
          line-height: $fontSecond;
          height: $fontSecond;
        }

        .introduce {
          color: #a5a3b2;
          font-size: $fontMini;
          line-height: $fontCommon;
          margin-top: 2px;
          height: $fontCommon;
        }
      }
    }
</style>